var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.5827 6.50841V13.4917C18.5827 16.5251 16.7743 18.3334 13.741 18.3334H6.75768C3.72435 18.3334 1.91602 16.5251 1.91602 13.4917V6.50841C1.91602 6.08341 1.94935 5.67508 2.02435 5.30008C2.44935 3.00841 4.14102 1.67508 6.72435 1.66675H13.7743C16.3577 1.67508 18.0493 3.00841 18.4743 5.30008C18.5493 5.67508 18.5827 6.08341 18.5827 6.50841Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5827 6.50841V6.55008H1.91602V6.50841C1.91602 6.08341 1.94935 5.67508 2.02435 5.30008H6.72435V1.66675H7.97435V5.30008H12.5243V1.66675H13.7743V5.30008H18.4743C18.5493 5.67508 18.5827 6.08341 18.5827 6.50841Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2836 10.6L10.5503 9.60003C9.90859 9.23336 9.29193 9.18336 8.80859 9.45836C8.32526 9.73336 8.05859 10.3 8.05859 11.0334V13.0334C8.05859 13.7667 8.32526 14.3334 8.80859 14.6084C9.01693 14.725 9.25026 14.7834 9.49193 14.7834C9.82526 14.7834 10.1836 14.675 10.5503 14.4667L12.2836 13.4667C12.9253 13.1 13.2753 12.5834 13.2753 12.025C13.2753 11.4667 12.9169 10.975 12.2836 10.6Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.5b509ee5324fd7acd3640d1ecf0801c0.svg";
export { ForwardRef as ReactComponent };